import { CautionProps, cssVar } from '@cad-arc';
import { PillUnit, UnitStateGroupEnumType } from '@mark43/cad-api';
import { CautionLevelAttrId } from '../../socket/stream-types';
import { globalAttributes } from '../global-attributes';
import { colors } from '../../colors/colors';

export type UnitStatusKey = UnitStateGroupEnumType | 'NO_UNIT_STATE_GROUP';

export const unitStatusColors: Record<UnitStatusKey, { fill: string; text: string }> = {
    ADMIN: { fill: colors.unitStatusAdminFill, text: colors.unitStatusTextDark },
    AT_SCENE: { fill: colors.unitStatusAtSceneFill, text: colors.unitStatusAtSceneText }, //custom text color
    AVAILABLE: { fill: colors.unitStatusAvailableFill, text: colors.unitStatusTextLight },
    AVAILABLE_EVENT_RELATED: { fill: colors.unitStatusAvailableEventRelatedFill, text: colors.unitStatusTextLight },
    AVAILABLE_NON_EVENT_RELATED: { fill: colors.unitStatusAvailableNonEventRelatedFill, text: colors.unitStatusTextLight },
    DIRECTED_PATROL: { fill: colors.unitStatusDirectedPatrolFill, text: colors.unitStatusTextLight },
    DISPATCHED: { fill: colors.unitStatusDispatchedFill, text: colors.unitStatusTextLight },
    EN_ROUTE: { fill: colors.unitStatusEnRouteFill, text: colors.unitStatusTextLight },
    EN_ROUTE_ALTERNATE: { fill: colors.unitStatusEnRouteAlternateFill, text: colors.unitStatusTextLight },
    HOSPITAL_TRANSPORT_ARRIVED: { fill: colors.unitStatusHospitalTransportArrivedFill, text: colors.unitStatusTextDark },
    HOSPITAL_TRANSPORT_EN_ROUTE: { fill: colors.unitStatusHospitalTransportEnRouteFill, text: colors.unitStatusTextDark },
    NO_UNIT_STATE_GROUP: { fill: colors.unitStatusNoUnitStateGroupFill, text: colors.unitStatusNeutralText },
    OFF_DUTY: { fill: colors.unitStatusOffDutyFill, text: colors.unitStatusNeutralText },
    OUT_OF_SERVICE: { fill: colors.unitStatusOutOfServiceFill, text: colors.unitStatusNeutralText },
    PURSUIT_ARRIVED: { fill: colors.unitStatusPursuitArrivedFill, text: colors.unitStatusTextDark },
    PURSUIT_EN_ROUTE: { fill: colors.unitStatusPursuitEnRouteFill, text: colors.unitStatusTextLight },
    REPORT_WRITING: { fill: colors.unitStatusReportWritingFill, text: colors.unitStatusTextLight },
    RESPONDING_COURT_ARRIVED: { fill: colors.unitStatusRespondingCourtArrivedFill, text: colors.unitStatusTextLight },
    RESPONDING_COURT_EN_ROUTE: { fill: colors.unitStatusRespondingCourtEnRouteFill, text: colors.unitStatusTextDark },
    SERVICE_ASSIGNMENT: { fill: colors.unitStatusServiceAssignmentFill, text: colors.unitStatusTextDark },
    SPECIAL_ASSIGNMENT: { fill: colors.unitStatusSpecialAssignmentFill, text: colors.unitStatusTextDark },
    STAGING: { fill: colors.unitStatusStagingFill, text: colors.unitStatusTextLight },
    SYSTEM_DISPATCHED: { fill: colors.unitStatusSystemDispatchedFill, text: colors.unitStatusTextLight },
    TRANSPORT_ARRIVED: { fill: colors.unitStatusTransportArrivedFill, text: colors.unitStatusTextLight },
    TRANSPORT_EN_ROUTE: { fill: colors.unitStatusTransportEnRouteFill, text: colors.unitStatusTextDark },
    UNAVAILABLE: { fill: colors.unitStatusUnavailableFill, text: colors.unitStatusTextLight},
    UNMANNED: { fill: colors.unitStatusUnmannedFill, text: colors.unitStatusNeutralText },
    UNIT_EMERGENCY: { fill: colors.unitStatusUnitEmergencyFill, text: colors.unitStatusTextLight },
    VIRTUAL_PATROL: { fill: colors.unitStatusVirtualPatrolFill, text: colors.unitStatusTextDark },
};

export function getColorForHeldUnit(unit: PillUnit): {outline: string; text: string} {
    if (unit.isAssignedToAnotherEvent) {
        switch (unit.unitStateGroup) {
            case 'AVAILABLE_EVENT_RELATED':
                return {outline: colors.unitStatusAvailableEventRelatedHeldFill, text: colors.unitStatusHeldText};
            default:
                return  {outline: colors.unitStatusUnavailableHeldFill, text: colors.unitStatusHeldText};
        }
    } else {
        switch (unit.unitStateGroup) {
            // it shouldn't be possible for a unit to be OFF_DUTY and held
            // but if they were they would display the unavailable color
            case 'OFF_DUTY':
            case 'OUT_OF_SERVICE':
            case 'UNAVAILABLE':
            case 'UNMANNED':
                return {outline: colors.unitStatusUnavailableHeldFill, text: colors.unitStatusHeldText};
            default:
                return {outline: colors.unitStatusAvailableEventRelatedHeldFill, text: colors.unitStatusHeldText};
        }
    }
}

export const cautionLevelColors = {
    [globalAttributes.locationCautionPriorityGlobal.PRIORITY_1]: colors.cautionMarkerPriority1,
    [globalAttributes.locationCautionPriorityGlobal.PRIORITY_2]: colors.cautionMarkerPriority2,
    [globalAttributes.locationCautionPriorityGlobal.PRIORITY_3]: colors.cautionMarkerPriority3,
    [globalAttributes.locationCautionPriorityGlobal.PRIORITY_4]: cssVar('arc.colors.icon.default'),
} as const;

export const locationCautionPriorityToLevel = (
    locationCautionPriorityGlobal: CautionLevelAttrId
) => {
    const globalAttributeToPriorityMap: Record<CautionLevelAttrId, CautionProps['priority']> = {
        [globalAttributes.locationCautionPriorityGlobal.PRIORITY_1]: 1,
        [globalAttributes.locationCautionPriorityGlobal.PRIORITY_2]: 2,
        [globalAttributes.locationCautionPriorityGlobal.PRIORITY_3]: 3,
        [globalAttributes.locationCautionPriorityGlobal.PRIORITY_4]: 4,
    };
    return globalAttributeToPriorityMap[locationCautionPriorityGlobal] || 4;
};
